import {
  Box,
  Select,
  MenuItem,
  FormControl,
  Typography,
  Pagination,
} from "@mui/material";
import { CustomPaginationProps } from "./types";

const CustomPagination = ({
  currentPage,
  totalPages,
  itemsPerPage,
  setItemsPerPage,
  setCurrentPage,
  currentPageItems,
  totalItems,
}: CustomPaginationProps) => {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mt: 3,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
          <Typography variant="body2" color="text.secondary">
            Mostrando {currentPageItems} de {totalItems} comercios
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Typography variant="body2" color="text.secondary">
              Mostrar:
            </Typography>
            <FormControl size="small">
              <Select
                value={itemsPerPage.toString()}
                onChange={(e) => {
                  setItemsPerPage(Number.parseInt(e.target.value));
                  setCurrentPage(1);
                }}
                sx={{ minWidth: 80 }}
              >
                <MenuItem value="5">5</MenuItem>
                <MenuItem value="10">10</MenuItem>
                <MenuItem value="20">20</MenuItem>
                <MenuItem value="50">50</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </Box>
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={(_, page) => setCurrentPage(page)}
          color="standard"
          showFirstButton
          showLastButton
        />
      </Box>
    </>
  );
};

export default CustomPagination;
